export const userActionTypes = {
  AccountsRead: 'Accounts.Read',
  AccountsReadWrite: 'Accounts.ReadWrite',
  CardsRead: 'Cards.Read',
  CardsReadWrite: 'Cards.ReadWrite',
  CashRead: 'Cash.Read',
  CashReadWrite: 'Cash.ReadWrite',
  MaintenanceRead: 'Maintenance.Read',
  MaintenanceReadWrite: 'Maintenance.ReadWrite',
  ReportsRead: 'Reports.Read',
  ReportsReadWrite: 'Reports.ReadWrite',
  UsersImpersonate: 'Users.Impersonate',
  UsersRead: 'Users.Read',
  UsersReadWrite: 'Users.ReadWrite',
  PortalAccess: 'Portal.Access',
  AdminPortalAccess: 'AdminPortal.Access'
};

export const isAuthorised = (user, assignedGrandfatherClientNumber, actions) => {
  if ((!isAmpolAdmin(user) && !assignedGrandfatherClientNumber) || !actions) {
    return false;
  }

  const roleId = user.accounts?.find(x => x.grandParentAccountNumber === assignedGrandfatherClientNumber)?.roleId;  
  const userActions = user.roles?.find(x => x.id === roleId)?.actions || user.roles?.find(x => x?.actions?.allow?.includes(userActionTypes.AdminPortalAccess)).actions;
  
  return userActions?.allow.some(value=> actions.some(a => value.includes(a)));
};

export const isAmpolAdmin = (user) => {
  return user.roles?.some(x => x.actions?.allow?.includes(userActionTypes.AdminPortalAccess));
};

export const isCustomer = (user) => {
  return user.roles?.some(x => x.actions?.allow?.includes(userActionTypes.PortalAccess));
};

export const getAssignAccountsUserMap = (account, grandParentAccount, parentAccount) => {
  let payload = {};

  if (grandParentAccount && parentAccount) {
    payload = {
      grandfatherClientNumber: grandParentAccount.accountNumber,
      // accountName: grandParentAccount.accountName,
      level: grandParentAccount.level,
      assignedAccountIds: [
        {
          parentAccountNumber: parentAccount.accountNumber,
          // accountName: parentAccount.accountName,
          level: parentAccount.level,
          accounts: [
            {
              accountNumber: account.accountNumber,
              // accountName: account.accountName,
              level: account.level
            }
          ]
        }
      ]
    };
  } else if (grandParentAccount) {
    payload = {
      grandfatherClientNumber: grandParentAccount.accountNumber,
      // accountName: grandParentAccount.accountName,
      level: grandParentAccount.level,
      assignedAccountIds: [
        {
          parentAccountNumber: account.accountNumber,
          // accountName: account.accountName,
          level: account.level,
          accounts: []
        }
      ]
    };
  } else if (parentAccount) {
    payload = {
      grandfatherClientNumber: parentAccount.accountNumber,
      // accountName: parentAccount.accountName,
      level: parentAccount.level,
      assignedAccountIds: [
        {
          parentAccountNumber: account.accountNumber,
          // accountName: account.accountName,
          level: account.level,
          accounts: []
        }
      ]
    };
  } else {
    payload = {
      grandfatherClientNumber: account.accountNumber,
      // accountName: account.accountName,
      level: account.level,
      assignedAccountIds: []
    };
  }

  return [payload];
};
